import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const DeleteJobFamilyModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "DeleteJobFamilyModalContainer" */
      './DeleteJobFamilyModalContainer'
    ),
  loading: LoadingModal,
});
